import { call, fork, put, take } from 'redux-saga/effects';
import { REQUEST } from 'redux-config/reduxHelpers';
import * as api from 'crm/_api/api';
import { SubmissionError } from 'redux-form';
import { acceptError } from 'common/_redux';
import { getAllReassignsTasksSaga, getTasksCountsNewSaga } from 'crm/tasks/_redux/sagas';
import * as ActionTypes from '../actions';

export function* changeReassignTaskStatusSaga({ search, ...payload }) {
  try {
    yield call(getAllReassignsTasksSaga, { search });
    const { status, data } = yield call(api.changeReassignTaskStatus, payload);
    if (status < 300) {
      yield put(ActionTypes.changeReassignTaskStatus.success());
      yield call(getAllReassignsTasksSaga, { search });
      yield call(getTasksCountsNewSaga);
    } else {
      const error = data.detail ? { _error: data.detail } : data;
      yield put(acceptError(data.detail, true));
      yield put(ActionTypes.changeReassignTaskStatus.failure(new SubmissionError(error)));
    }
  } catch (error) {
    yield put(acceptError(error, true));
    yield put(ActionTypes.changeReassignTaskStatus.failure(error));
  }
}

export function* changeReassignTaskStatusWatcherSaga() {
  while (true) {
    const data = yield take(ActionTypes.CHANGE_REASSIGN_TASK_STATUS[REQUEST]);
    yield call(changeReassignTaskStatusSaga, data);
  }
}

export default [fork(changeReassignTaskStatusWatcherSaga)];
